import { CSSProperties } from "react"
import "src/shared/components/layout/skeleton/Skeleton.css"

interface SkeletonItemProps {
    width?: CSSProperties["width"]
    height?: CSSProperties["height"]
    borderRadius?: CSSProperties["borderRadius"]
    style?: CSSProperties
}

function SkeletonItem({ width = "100%", height = "100%", borderRadius = 8, style }: SkeletonItemProps) {
    return (
        <div
            className="skeleton-item-base"
            style={{ width, height, borderRadius, ...style }}
        />
    )
}

export default SkeletonItem
